import React, { useEffect } from 'react'
import { DashboardContentContainer } from './styles'
import { OncologySidePanel } from '../sidePanel'
import { OncologyMainPanel } from '~/components/oncologyMedicalView'
import { OpenCloseProvider, useOncologyHealthProcedures, usePatient } from '~/context'

import { CreateHealthProcedureDetails } from '~/components/healthProcedures/CreateHealthProcedureDetails'

export const OncologyContent = (): JSX.Element => {
  const { patient } = usePatient()
  const {
    getHealthProcedures,
    displayedHealthProcedures,
    isLoadingTimeline,
    modalHealthProcedure,
    closeHealthProcedureDetails
  } = useOncologyHealthProcedures()

  useEffect(() => {
    getHealthProcedures({ pathParams: { patientId: patient.id } })
  }, [getHealthProcedures, patient.id])

  const hasData = (): boolean => {
    return !!(displayedHealthProcedures && displayedHealthProcedures.length > 0)
  }

  const isFetchingHealthProcedures = (): boolean => {
    return isLoadingTimeline
  }

  return (
    <>
      <DashboardContentContainer>
        <OpenCloseProvider>
          <OncologyMainPanel isLoading={isFetchingHealthProcedures()} hasData={hasData()} />
          <OncologySidePanel />
        </OpenCloseProvider>
      </DashboardContentContainer>
      <CreateHealthProcedureDetails
        handleSelectedModalHealthProcedures={closeHealthProcedureDetails}
        selectedPatient={() => patient.id}
        modalHealthProcedure={modalHealthProcedure}
      />
    </>
  )
}
